var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('transition',{attrs:{"name":"fade"}},[_c('loading')],1):_c('codemirror-editor')
}
var staticRenderFns = []

export { render, staticRenderFns }